export default __webpack_public_path__ + "static/N0072-657b0be11e9c797a16f7bc20ee884c03.png";